<template>
  <section
    v-if="haveCrossSellAndUpSell"
    class="row"
  >
    <div class="col-12 mb-1">
      <div class="h5 mb-1">
        Nos conseils
      </div>
      <p>
        Nous vous conseillons les protections
        supplémentaires qui sont adaptées à vos besoins
      </p>
    </div>
    <transition name="fade">
      <div
        v-if="isReady"
        class="col-12"
      >
        <div class="row">
          <div
            v-if="contractsNotOwned.length > 0"
            class="col-12"
            :class="{ 'col-md-7 pe-md-3': contractsWithExtensions.length > 0 }
            "
          >
            <div class="row d-flex flex-md-row flex-column mb-5 mb-md-0">
              <v-cross-sell
                v-if="contractsNotOwned.length > 0"
                :product="contractsNotOwned[0]"
                :class="{ 'col mb-3 mb-md-0': haveDoubleCrossSell }"
              />
              <v-cross-sell
                v-if="haveDoubleCrossSell"
                :product="contractsNotOwned[1]"
                :class="{ 'col mb-3 mb-md-0': haveDoubleCrossSell }"
              />
            </div>
          </div>
          <div
            class="col-12"
            :class="{ 'col-md-5': contractsNotOwned.length > 0 }"
          >
            <div class="row d-flex flex-md-row flex-column">
              <v-up-sell
                v-if="contractsWithExtensions.length > 0"
                :key="`upSellCard-${contractsWithExtensions[0].extension.id}`"
                :contract="contractsWithExtensions[0].contract"
                :extension="contractsWithExtensions[0].extension"
                :class="{ 'col-12 col-md-6 mb-3 mb-md-0': contractsWithExtensions.length > 1
                  && contractsNotOwned.length === 0 }"
                @update="setupUpSellCards"
              />
              <v-up-sell
                v-if="contractsWithExtensions.length > 1 && contractsNotOwned.length === 0"
                :key="`upSellCard-${contractsWithExtensions[1].extension.id}`"
                :contract="contractsWithExtensions[1].contract"
                :extension="contractsWithExtensions[1].extension"
                class="col-12 col-md-6 mb-3 mb-md-0"
                @update="setupUpSellCards"
              />
            </div>
          </div>
        </div>
      </div>
      <v-loading-animation v-else />
    </transition>
  </section>
</template>
<script>
import { uniqBy, shuffle } from 'lodash-es';
import { mapGetters } from 'vuex';

import LoadingAnimation from '@/components/common/helpers/LoadingAnimation.vue';
import CrossSellCard from './cards/HomeCrossSellCard.vue';
import UpSellCard from './cards/HomeUpSellCard.vue';

export default {
  components: {
    'v-cross-sell': CrossSellCard,
    'v-up-sell': UpSellCard,
    'v-loading-animation': LoadingAnimation,
  },
  data() {
    return {
      contractsWithExtensions: [],
      contractsNotOwned: [],
      isReady: false,
    };
  },
  computed: {
    ...mapGetters({
      contracts: 'contracts/get',
      recommendation: 'rater/recommendation',
    }),
    haveCrossSellAndUpSell() {
      return this.contractsNotOwned.length > 0
        || this.contractsWithExtensions.length > 0;
    },
    crossSellLength() {
      return this.contractsNotOwned.length;
    },
    haveDoubleCrossSell() {
      return this.contractsNotOwned.length > 1
        && this.contractsWithExtensions.length === 0;
    },
    haveDoubleUpSell() {
      return this.contractsNotOwned.length === 0
        && this.contractsWithExtensions.length > 1;
    },
    ownedProducts() {
      const contracts = this.contracts
        .filter(({ status }) => status !== 'QUOTED');
      return (uniqBy(contracts, 'productId') || [])
        .filter(({ status }) => status === 'ACTIVE')
        .map(({ productId }) => productId);
    },
  },
  created() {
    this.setupCrossSellCards();
    this.setupUpSellCards();
  },
  methods: {
    async setupCrossSellCards() {
      await this.$store.dispatch('rater/getRecommendation');
      // setup contracts for Cross sell cards
      const products = (this.recommendation || [])
        .filter(({ productId }) => !this.ownedProducts.some((id) => productId === id));
      this.contractsNotOwned = shuffle(products);
      this.isReady = true;
    },
    setupUpSellCards() {
      // setup contracts for Upsell cards
      const extensionsWithContracts = this.contracts
        .filter(({ status }) => status === 'ACTIVE')
        .reduce((acc, iter) => {
          const extensions = (iter.extensions || [])
            .filter(({ enabled, visible }) => !enabled && visible)
            .map((extension) => ({ extension, contract: iter }));
          if (extensions.length > 0) {
            acc.push(...extensions);
          }
          return acc;
        }, []);
      this.contractsWithExtensions = shuffle(extensionsWithContracts);
    },
  },
};
</script>
